module.exports = __webpack_public_path__ + "img/Asistencia Legal.93531edc.svg";